import React from 'react';
import { triangle, btnClear, arrowBack } from '../../Images/GenericSVG';
import { btnCerrar } from '../../Images/Images';
import { validateOnlyNumbers } from '../../js/helpers/Utils/Validations';
import { Singleton } from '../../js/Singleton';
var language = new Singleton();

export const CUSTOM_COMPONENTS = {
  bigDisplayer: (displayerFunction, customStyles = { height: 30, width: 30 }, inverted) => {
    return <div className="arrowButton" onClick={displayerFunction} style={customStyles}><div className={"containerTriangle " + (inverted && "inverted")}>{triangle}</div></div>;
  },
  displayBlack: (displayerFunction, customStyles = { height: 24, width: 24 }, inverted) => {
    return <div className="arrowButtonBlack" onClick={displayerFunction} style={customStyles}><div className={"containerTriangle " + (inverted && "inverted")}>{triangle}</div></div>;
  },
  texSelection: (text = language.getText("CallControlCRMxcontrolsselectAnOption"), styles = "textSelection") => {
    return <p className={styles}>{text}</p>;
  },
  draggableHeader: (icon, title = "Ventana", closeFunction, classes) => {
    return <drag>
      <div className="floatingHeader">
        <div className={`iconFloatingHeader ${classes && classes.iconHeader}`}>{icon}</div>
        <p className="titleFloatingHeader">{title}</p>
        {closeFunction && <img className="buttonFloatingClose" onClick={closeFunction} src={btnCerrar} alt="close"></img>}
      </div>
    </drag>
  },
  sideBarHeader: (iconSVG, title = "Ventana") => {
    return <div className="sideBarHeader">
      <div className="sideBarICon">{iconSVG}</div>
      <p className="sideBarTitle">{title}</p>
    </div>
  },
  configBarHeader: (icon, title, backFunction, backHiden = false) => {
    return <div className="configBarHeader">
      <div className={"backConfigBar " + (backHiden ? "hidden" : "")} onClick={backFunction}>{arrowBack}</div>
      <img className="iconConfigBar" src={icon} alt="icon"></img>
      <p className="txtConfigBar">{title}</p>
    </div>
  },
  inputDelete: (value, newValue, className, inputClass, deleteClass, svgClose = btnClear, onlyNumbers, image, imageClass, placeholder, disabled=false) => {
    return <div className={className}>
      {image && <img className={imageClass} src={image} alt="close"></img>}
      <input type="text"
        placeholder={placeholder}
        className={inputClass}
        value={value}
        onKeyPress={evt => { onlyNumbers && validateOnlyNumbers(evt) ? true : undefined }}
        onChange={event => { newValue(event.target.value) }} 
        maxlength="20"
        readOnly={disabled}/>
      {value !== "" && <div className={deleteClass} onClick={() => newValue("")}>{svgClose}</div>}
    </div>
  },
  configCampaignType:(title,backFunction, backHiden = false)=> {
    return <div className="configBarHeader">
      <div className={"backConfigBar " + (backHiden ? "hidden" : "")} onClick={backFunction}>{arrowBack}</div>
      <i className="iconConfigBar  gcl-icon camps" alt="icon"></i>
      <p className="txtConfigBar">{title}</p>
    </div>
  }
};


// WEBPACK FOOTER //
// ./src/js/customElements/customComponents.js